<template>
  <div>
    <v-btn @click="openDialog" icon v-tooltip="'Notas de Atualização'">
      <v-badge
        v-if="unreadCount > 0"
        color="red"
        :content="unreadCount > 99 ? '99+' : unreadCount"
        overlap
      >
        <v-icon>mdi-bullhorn-variant</v-icon>
      </v-badge>
      <v-icon v-else>mdi-bullhorn-variant-outline</v-icon>
    </v-btn>

    <ReleaseNotesDialog
      :dialog="showDialog"
      @update:dialog="showDialog = $event"
      @notes-read="fetchUnreadCount"
    />
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useHttp, useIp } from "@/composables";
import ReleaseNotesDialog from "./ReleaseNotesDialog.vue";

const http = useHttp();
const ips = useIp();

const showDialog = ref(false);
const unreadCount = ref(0);

onMounted(() => {
  fetchUnreadCount();
});

function openDialog() {
  showDialog.value = true;
}

async function fetchUnreadCount() {
  try {
    const res = await http.post(ips.ipUser + "release-note/unread-count", {});
    if (res && res.data) {
      unreadCount.value = res.data.unreadCount || 0;
    }
  } catch (err) {
    console.error("Erro ao buscar contagem de notas:", err);
  }
}
</script>
